// extracted by mini-css-extract-plugin
export default {"faq":"FAQ_faq__W8V5o","faqQuestion":"FAQ_faqQuestion__Y2QGq","faqAnswer":"FAQ_faqAnswer__Koq6M","open":"FAQ_open__MHD4A","disabled":"FAQ_disabled__RbpQr"};